module.exports = __webpack_public_path__ + "assets/img/mecha-677ee30d.png";